import { useSelector } from 'react-redux';
import {Navigate} from 'react-router-dom';
import Loader from '../layouts/Loader';

export default function ProtectedRoute ({children, isAdmin, isStrictAdmin, isMasterOnly, allowDoctor}) {
    const { isAuthenticated, loading, user } = useSelector(state => state.authState)

    if(!isAuthenticated && !loading) {
        return <Navigate to="/" />
    }

    if(isAuthenticated) {
        if (isMasterOnly === true && user?.role !== 'master') {
            return <Navigate to="/dashboard" />
        }
        if (isStrictAdmin === true) {
            const isDoctorAllowed = allowDoctor && user?.role === 'doctor';
            if (user?.role !== 'admin' && user?.role !== 'master' && !isDoctorAllowed) {
                return <Navigate to="/dashboard" />
            }
        }
        if (isAdmin === true && user?.role !== 'admin' && user?.role !== 'manager' && user?.role !== 'master') {
            return <Navigate to="/dashboard" />
        }
    }

    if(loading) {
        return <Loader/>
    }

    return children;
}